(() => {
  if (window.ProtekQuickAdd) return;
  window.ProtekQuickAdd = true;

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const statusNode = () => {
    let node = document.querySelector('[data-protek-cart-status]');
    if (!node) {
      node = document.createElement('div');
      node.className = 'visually-hidden';
      node.setAttribute('data-protek-cart-status', '');
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      document.body.appendChild(node);
    }
    return node;
  };

  const updateCartBadge = (count) => {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;
    let bubble = cartIcon.querySelector('.cart-count-bubble');
    if (count < 1) {
      if (bubble) bubble.remove();
      return;
    }
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      cartIcon.appendChild(bubble);
    }
    const visible = bubble.querySelector('[aria-hidden="true"]');
    const accessible = bubble.querySelector('.visually-hidden');
    if (visible) visible.textContent = count < 100 ? String(count) : '';
    if (accessible) accessible.textContent = count + (count === 1 ? ' item' : ' items');
  };

  const setButtonState = (button, state, title) => {
    button.classList.remove('is-loading', 'is-added', 'is-error');
    if (state) button.classList.add('is-' + state);
    const symbol = button.querySelector('.protek-phone-card__cart-icon b');
    if (symbol) symbol.textContent = state === 'added' ? '✓' : state === 'error' ? '!' : '+';
    if (state === 'loading') {
      button.disabled = true;
      button.setAttribute('aria-label', 'Adding ' + title + ' to cart');
    } else if (state === 'added') {
      button.disabled = true;
      button.setAttribute('aria-label', 'Added ' + title + ' to cart');
    } else {
      button.disabled = false;
      button.setAttribute('aria-label', 'Add ' + title + ' to cart');
    }
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-protek-quick-add]');
    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = Number(button.dataset.variantId);
    const title = button.dataset.productTitle || 'product';
    if (!variantId) {
      window.location.href = button.dataset.productUrl || '/collections/all';
      return;
    }

    setButtonState(button, 'loading', title);
    statusNode().textContent = 'Adding ' + title + ' to cart';

    try {
      const response = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: variantId, quantity: 1}]})
      });
      if (!response.ok) throw new Error('Unable to add item');

      const cartResponse = await fetch(root() + 'cart.js', {
        headers: {'Accept': 'application/json'}
      });
      if (!cartResponse.ok) throw new Error('Unable to refresh cart');
      const cart = await cartResponse.json();

      updateCartBadge(cart.item_count || 0);
      setButtonState(button, 'added', title);
      statusNode().textContent = title + ' was added to your cart';
      document.dispatchEvent(new CustomEvent('protek:cart-updated', {detail: {cart}}));

      window.setTimeout(() => setButtonState(button, '', title), 1600);
    } catch (error) {
      setButtonState(button, 'error', title);
      statusNode().textContent = title + ' could not be added. Please try again.';
      window.setTimeout(() => setButtonState(button, '', title), 2200);
    }
  });
})();